import React, { useEffect, useState } from "react";
import { BarChart3, RefreshCw, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api from "../../lib/apiClient";

export default function CashbackAnalytics() {
  const [d, setD] = useState(null);
  const load = () => api.get("/admin/cashback/distribution").then((r) => setD(r.data)).catch(() => toast.error("Failed"));
  useEffect(() => { load(); }, []);
  if (!d) return <div className="flex justify-center py-20"><Loader2 className="h-6 w-6 animate-spin text-emerald-500" /></div>;
  const maxCount = Math.max(1, ...d.distribution.map((x) => x.count));

  return (
    <div className="space-y-6" data-testid="admin-cashback-analytics">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2"><BarChart3 className="h-5 w-5 text-pink-400" /><h1 className="font-heading text-2xl font-bold">Cashback distribution</h1></div>
        <button data-testid="cashback-refresh" onClick={load} className="inline-flex items-center gap-2 rounded-full border border-slate-700 px-4 py-2 text-sm hover:border-pink-500/50"><RefreshCw className="h-4 w-4" /> Refresh</button>
      </div>
      <p className="text-xs text-slate-500">The backend decides every reward (weighted lucky draw, budget-capped). This is a monitoring view of the actual distribution — the scratch animation never decides the amount.</p>

      <div className="grid gap-4 sm:grid-cols-3">
        <Card label="Total draws" value={d.total_draws.toLocaleString("en-IN")} testid="cashback-total-draws" />
        <Card label="Total cashback cost" value={d.total_cost.display} accent testid="cashback-total-cost" />
        <Card label="Average payout" value={d.avg_display} testid="cashback-avg" />
      </div>

      <div className="ledger-card rounded-2xl p-6" data-testid="cashback-distribution-chart">
        <p className="font-mono text-[11px] uppercase tracking-widest text-slate-500">Distribution by denomination</p>
        <div className="mt-4 space-y-3">
          {d.distribution.map((x) => (
            <div key={x.denomination_paise} data-testid={`dist-bar-${x.denomination_paise}`} className="flex items-center gap-3">
              <span className="w-20 shrink-0 text-right font-mono text-sm text-slate-300">{x.denomination_display}</span>
              <div className="relative h-7 flex-1 overflow-hidden rounded-lg bg-slate-800/60">
                <div className="h-full rounded-lg bg-gradient-to-r from-pink-500 to-fuchsia-400 transition-all" style={{ width: `${(x.count / maxCount) * 100}%` }} />
                <span className="absolute inset-y-0 left-2 flex items-center font-mono text-xs text-white/90">{x.count} · {x.pct}%</span>
              </div>
              <span className="w-24 shrink-0 text-right font-mono text-xs text-slate-400">{x.cost_display}</span>
            </div>
          ))}
        </div>
      </div>

      <div className="ledger-card rounded-2xl p-6">
        <p className="font-mono text-[11px] uppercase tracking-widest text-slate-500">Transaction status breakdown</p>
        <div className="mt-3 flex flex-wrap gap-3">
          {Object.entries(d.status_counts).map(([k, v]) => (
            <span key={k} className="rounded-full bg-slate-900 px-4 py-2 text-sm"><span className="font-mono text-pink-300">{k}</span> <span className="font-heading font-bold">{v}</span></span>
          ))}
        </div>
      </div>
    </div>
  );
}

function Card({ label, value, accent, testid }) {
  return <div className="ledger-card rounded-2xl p-5" data-testid={testid}><p className="font-mono text-[11px] uppercase tracking-widest text-slate-500">{label}</p><p className={`mt-2 font-heading text-2xl font-extrabold ${accent ? "text-pink-400" : "text-slate-100"}`}>{value}</p></div>;
}
